"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.borderWidths = void 0;
var borderWidths_1 = __importDefault(require("../tokens/borderWidths"));
exports.borderWidths = borderWidths_1.default;
//# sourceMappingURL=borderWidths.js.map